import React from "react";
// MATERIAL UI
import { TypographyBoldOnPrint } from "../styled";
import { StyledGreyBadgeNoBackgroundOnPrint } from "../styled/badge";

const LabelHorizontal = ({
  label,
  align = "start",
  isbold,
  backgroundColor = "transparent",
}) => {
  return (
    <StyledGreyBadgeNoBackgroundOnPrint
      backgroundcolor={backgroundColor}
      sx={{ ml: 1 }}
    >
      <TypographyBoldOnPrint
        variant="body1"
        textAlign={align}
        fontWeight={isbold ? "bold" : "normal"}
        printsize={10}
      >
        {label}
      </TypographyBoldOnPrint>
    </StyledGreyBadgeNoBackgroundOnPrint>
  );
};

export default LabelHorizontal;
